import Immutable from 'immutable';
import AuthApi from '../api/AuthApi';
import AuthConstants from '../constants/AuthConstants';

function loadUser() {
  return {
    types: [
      AuthConstants.AUTH_LOAD_USER_REQUEST,
      AuthConstants.AUTH_LOAD_USER_SUCCESS,
      AuthConstants.AUTH_LOAD_USER_FAILURE
    ],
    apiRequest: (state, client) => AuthApi.loadUser(client)
  };
}

function login(username, password) {
  return {
    messaging: false,
    types: [AuthConstants.AUTH_LOGIN_REQUEST, AuthConstants.AUTH_LOGIN_SUCCESS, AuthConstants.AUTH_LOGIN_ERROR],
    apiRequest: (state, client) => AuthApi.login(username, password, client),
    postSuccess: state => {
      const postLoginAction = state.getIn(['auth', 'postLoginAction']);
      if (Immutable.Iterable.isIterable(postLoginAction)) {
        return postLoginAction.toJS();
      }
      return postLoginAction;
    }
  };
}

function logout() {
  return {
    type: AuthConstants.AUTH_LOGOUT
  };
}

function closeLoginDialog() {
  return {
    type: AuthConstants.CLOSE_LOGIN_DIALOG
  };
}

export default {
  login,
  logout,
  loadUser,
  closeLoginDialog
};
